import { render, staticRenderFns } from "./provincialDetail.vue?vue&type=template&id=329cdbde&scoped=true"
import script from "./provincialDetail.vue?vue&type=script&lang=js"
export * from "./provincialDetail.vue?vue&type=script&lang=js"
import style0 from "./provincialDetail.vue?vue&type=style&index=0&id=329cdbde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329cdbde",
  null
  
)

export default component.exports